import { authenticatedMiddleware } from '../../permissions/middlewares/authenticatedMiddleware.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { HealthInsurance } from '../entities/HealthInsurance.js';
import { resolveHealthInsuranceANSoVeRefCount } from '../server/resolver/resolveHealthInsuranceANSoVeRefCount.js';
import { resolveSubscribeHealthInsurancesByFilterPaginated } from '../server/resolver/resolveSubscribeHealthInsurancesByFilterPaginated.js';

const getHealthInsuranceANSoVeRefCount = registerQuery({
  operationName: 'getHealthInsuranceANSoVeRefCount',
  middlewares: [authenticatedMiddleware],
  type: () => Int,
  params: [{ name: 'insuranceID', type: () => String }],
  resolve: resolveHealthInsuranceANSoVeRefCount,
});

const subscribeHealthInsurancesByFilterPaginated = registerSubscription({
  operationName: 'subscribeHealthInsurancesByFilterPaginated',
  middlewares: [authenticatedMiddleware],
  type: () => [HealthInsurance],
  params: [
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
    {
      name: 'filter',
      type: () => AdornisFilter,
    },
  ],
  resolve: resolveSubscribeHealthInsurancesByFilterPaginated,
});

export namespace HealthInsuranceAPI {
  export const getANSoVeRefCount = getHealthInsuranceANSoVeRefCount;
  export const subscribeByFilterPaginated = subscribeHealthInsurancesByFilterPaginated;
}
